import styled from "@emotion/styled";
export const ExpressionPopoverRoot = styled.div`
  min-width: 350px;
`;
